import { getBirdviewBuildings } from '../../DashboardBirdview.api'
import { sortBirdviewLoadItems } from '../../DashboardBirdview.utils'
import { getBirdviewBuildingsFilters } from '../../DashboardBirdview.utils.api'
import { useBirdviewRequestLoaders } from '../useBirdviewRequestLoaders'

import {
  getBirdviewBuildingOpenRequestsFilters,
  getBirdviewBuildingOverdueRequestsFilters,
  toBirdviewBuildingItem,
} from './useBirdviewPropertiesLoaders.utils'

export function useBirdviewPropertiesLoaders() {
  const { getRequestsCountTile } = useBirdviewRequestLoaders()

  async function getBuildingLoad(building) {
    const [{ count: open }, { count: overdue }] = await Promise.all([
      getRequestsCountTile(getBirdviewBuildingOpenRequestsFilters(building.id)),
      getRequestsCountTile(
        getBirdviewBuildingOverdueRequestsFilters(building.id)
      ),
    ])

    return { ...building, open, overdue }
  }

  // No per-building aggregate exists yet, so the load of the shown buildings is
  // counted one by one.
  async function getPropertiesSection(params) {
    const { data } = await getBirdviewBuildings(
      getBirdviewBuildingsFilters(params)
    )

    const items = await Promise.all(
      data.items.map(toBirdviewBuildingItem).map(getBuildingLoad)
    )

    return {
      items: sortBirdviewLoadItems(items),
      total: data.pagination.total,
    }
  }

  return { getPropertiesSection }
}
